import { useState } from 'react';
import { toast } from 'sonner';
import { MailCheck } from 'lucide-react';
import { bc } from '../lib/api';
import { useAuth } from '../lib/auth';

export default function EmailVerifyBanner() {
  const { user, refresh } = useAuth();
  const [sent, setSent] = useState(false);
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  if (!user?.login_email || user.email_verified || done) return null;

  const send = async () => {
    setBusy(true);
    try { const r = await bc.emailSend(); setSent(true); toast.success(`Code sent to ${r.email}`); if (r.dev_code) setCode(r.dev_code); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Could not send code'); } finally { setBusy(false); }
  };
  const verify = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await bc.emailVerify(code); toast.success('Email verified'); setDone(true); refresh?.(); }
    catch (err) { toast.error(err?.response?.data?.detail || 'Wrong code'); } finally { setBusy(false); }
  };
  return (
    <div data-testid="email-verify-banner" className="bg-[#E3F2FD] text-[#0D47A1] text-sm">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-2 flex flex-wrap items-center gap-2">
        <MailCheck className="w-4 h-4"/><span className="flex-1 min-w-[180px]">Please verify your email <b>{user.login_email}</b>.</span>
        {sent ? (
          <form onSubmit={verify} className="flex gap-2">
            <input data-testid="email-verify-code" value={code} onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))} placeholder="6-digit code" className="w-28 rounded-full border border-[#0D47A1]/30 px-3 py-1"/>
            <button data-testid="email-verify-submit" disabled={busy || code.length !== 6} className="rounded-full bg-[#0D47A1] text-white px-3 py-1 font-semibold disabled:opacity-50">Verify</button>
            <button type="button" onClick={send} disabled={busy} className="underline text-xs">Resend</button>
          </form>
        ) : <button data-testid="email-verify-send" onClick={send} disabled={busy} className="rounded-full bg-[#0D47A1] text-white px-3 py-1 font-semibold">Send code</button>}
      </div>
    </div>
  );
}
